import * as Yup from 'yup';

export const defaultValues = {
  twoFaCode: '',
  rememberBrowser: true,
};

const googleAuthenticatorNumberOfCharacters = 6;

export const validationSchema = Yup.object({
  twoFaCode: Yup.string()
    .required('2FA Authenticator Code is required')
    .min(
      googleAuthenticatorNumberOfCharacters,
      `Authenticator code must be ${googleAuthenticatorNumberOfCharacters} characters`
    )
    .max(
      googleAuthenticatorNumberOfCharacters,
      `Authenticator code must be ${googleAuthenticatorNumberOfCharacters} characters`
    ),
  rememberBrowser: Yup.boolean(),
});
